import {
    Activity,
    ArrowUpRight,
    Layers,
    MessageCircleQuestion,
    Microscope,
    RotateCcw,
    ShieldCheck,
    Sparkles,
    Wrench,
} from "lucide-react";
import { wa, waTratamento, MSG } from "../../data/site";
import { Reveal, SectionHeader } from "./Reveal";

const TREATMENTS = [
    {
        icon: Microscope,
        name: "Endodontia microscópica",
        desc: "Tratamentos endodônticos com auxílio da microscopia operatória para melhorar a visualização de estruturas e detalhes.",
    },
    {
        icon: Activity,
        name: "Tratamento de canal",
        desc: "Procedimento indicado para tratar determinadas alterações da polpa dentária e buscar preservar o dente natural.",
    },
    {
        icon: RotateCcw,
        name: "Retratamento de canal",
        desc: "Reavaliação e novo tratamento endodôntico quando houver indicação clínica.",
    },
    {
        icon: Sparkles,
        name: "Clareamento interno",
        desc: "Procedimento para tratar alterações de cor em determinados dentes que passaram por tratamento endodôntico.",
    },
    {
        icon: Layers,
        name: "Pino de fibra de vidro",
        desc: "Recurso restaurador que pode ser indicado para auxiliar na reconstrução de determinados dentes tratados endodonticamente.",
    },
    {
        icon: Wrench,
        name: "Remoção de material protético",
        desc: "Remoção de pinos, coroas ou outros materiais protéticos quando indicada para permitir a realização de um procedimento.",
    },
    {
        icon: ShieldCheck,
        name: "Selamento de perfurações e comunicações",
        desc: "Procedimentos especializados para tratar determinadas perfurações e comunicações dentárias, conforme a avaliação do caso.",
    },
];

export const Treatments = () => (
    <section id="tratamentos" data-testid="treatments-section" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader
                overline="Áreas de atendimento"
                title="Tratamentos especializados em Endodontia"
                subtitle="Conheça as possibilidades de atendimento e encontre a orientação adequada para o seu caso."
            />
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {TREATMENTS.map((t, i) => (
                    <Reveal key={t.name} delay={(i % 3) * 0.08} className="h-full">
                        <article
                            data-testid={`treatment-card-${i}`}
                            className="group flex h-full flex-col rounded-3xl border border-slate-200/80 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-[#BFDBFE] hover:shadow-xl hover:shadow-blue-600/5"
                        >
                            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#EFF5FF] text-[#1A6AFF] transition-colors duration-300 group-hover:bg-[#1A6AFF] group-hover:text-white">
                                <t.icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-6 text-lg font-semibold text-slate-900">{t.name}</h3>
                            <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                                {t.desc}
                            </p>
                            <a
                                href={waTratamento(t.name)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`treatment-cta-${i}`}
                                className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1A6AFF] transition-colors hover:text-[#0052E0]"
                            >
                                Consultar especialista
                                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </a>
                        </article>
                    </Reveal>
                ))}
                <Reveal delay={0.16} className="h-full">
                    <article
                        data-testid="treatment-card-other"
                        className="flex h-full flex-col justify-between rounded-3xl bg-[#1A6AFF] p-8 text-white shadow-xl shadow-blue-600/20 transition-all duration-300 hover:-translate-y-1.5"
                    >
                        <div>
                            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15 text-white">
                                <MessageCircleQuestion className="h-6 w-6" />
                            </span>
                            <h3 className="mt-6 text-lg font-semibold">Não encontrou o seu caso?</h3>
                            <p className="mt-3 text-sm leading-relaxed text-blue-100">
                                Cada situação é avaliada individualmente. Envie sua dúvida e receba a
                                orientação adequada.
                            </p>
                        </div>
                        <a
                            href={wa(MSG.consulta)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="treatment-cta-other"
                            className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-white underline-offset-4 hover:underline"
                        >
                            Falar com o Dr. Gabriel
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);
